export default __webpack_public_path__ + "static/media/consorcioLogo.fe9e3765.svg";